module.exports = __webpack_public_path__ + "img/sushitorteoben.8ca55e56.png";